/**
 * Specifies TreeMap beforePrint event name.
 *
 * @private
 */
export var smithchartBeforePrint = 'beforePrint';
